export default {
  namespaced: true,
  state:{
    products: [],
    productCreate: {
      modal: false,
      values: {}
    },
    productEdit: {
      modal: false,
      values: {}
    }
  },
  getters:{
    products(state){
      return state.products;
    },
    productCreate(state) {
      return state.productCreate;
    },
    productEdit(state) {
      return state.productEdit;
    }
  },
  mutations:{
    SET_PRODUCTS(state, values){
      state.products = values;
    },
    SET_PRODUCT_CREATE_MODAL(state, value) {
      state.productCreate.modal = value;
    },
    SET_PRODUCT_CREATE_VALUES(state, value) {
      state.productCreate.values = value;
    },
    SET_PRODUCT_EDIT_MODAL(state, value) {
      state.productEdit.modal = value;
    },
    SET_PRODUCT_EDIT_VALUES(state, value) {
      state.productEdit.values = value;
    },
    PUSH_PRODUCT(state, value){
      state.products.push(value);
    },
    SET_UPDATE_PRODUCT(state, values){
      var editedIndex = state.products.map(product => product.id).indexOf(values.id);
      if (editedIndex > -1){
        // Se reemplaza el objeto completo en lugar de Object.assign porque las
        // presentaciones son un arreglo anidado: al fusionar, las filas eliminadas
        // del arreglo nuevo quedarían visibles con los datos viejos.
        state.products.splice(editedIndex, 1, values);
      }
      return;
    }
  },
  actions:{
    getProducts({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get('admin/products').then((response) => {
          commit('SET_PRODUCTS', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
      });
    },
    productStore({commit}, payload) {
      // Se envía JSON y no FormData: las presentaciones son un arreglo de objetos y
      // FormData las aplanaría a texto.
      return new Promise((resolve, reject) => {
        axios.post('admin/products', payload).then((response) => {
          commit('PUSH_PRODUCT', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
      });
    },
    productUpdate({commit}, payload) {
      return new Promise((resolve, reject) => {
        axios.put('admin/products/' + payload.id, payload).then((response) => {
          commit('SET_UPDATE_PRODUCT', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
      });
    },
    productToggleActive({commit}, value) {
      return new Promise((resolve, reject) => {
        axios.patch('admin/products/' + value + '/toggle-active').then((response) => {
          commit('SET_UPDATE_PRODUCT', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
      });
    },
    productToggleLiquid({commit}, value) {
      return new Promise((resolve, reject) => {
        axios.patch('admin/products/' + value + '/toggle-liquid').then((response) => {
          commit('SET_UPDATE_PRODUCT', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
      });
    }
  }
}
